import { PureComponent, PropsWithChildren } from "react";

export default class PageHeader extends PureComponent<PropsWithChildren> {
  render() {
    const { children } = this.props;

    return <div className="builder-page-header">{children}</div>;
  }
}
